var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "#F1F9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.798 67.2339L52.7151 54.249L58.3106 44.9231L70.2097 67.2339H59.798ZM47.8989 50.8726L56.8233 67.2339H38.9746L47.8989 50.8726ZM44.1805 47.8979C43.1943 47.8979 42.2485 47.5061 41.5511 46.8088C40.8538 46.1114 40.462 45.1656 40.462 44.1794C40.462 43.1932 40.8538 42.2474 41.5511 41.5501C42.2485 40.8527 43.1943 40.4609 44.1805 40.4609C45.1667 40.4609 46.1125 40.8527 46.8098 41.5501C47.5072 42.2474 47.8989 43.1932 47.8989 44.1794C47.8989 45.1656 47.5072 46.1114 46.8098 46.8088C46.1125 47.5061 45.1667 47.8979 44.1805 47.8979Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLogo);
export default __webpack_public_path__ + "static/media/add-logo.ee7042d7150d25c11392a88ff517a1f5.svg";
export { ForwardRef as ReactComponent };